import { gql, TypedDocumentNode } from "@apollo/client";

export type PostM360FeedbackMutationResponse = {
  postM360Feedback: {
    success: boolean;
    message: string;
  };
};

export type PostM360FeedbackMutationVariables = {
  message: string;
  pageUrl?: string;
};

export const POST_M360_FEEDBACK_MUTATION: TypedDocumentNode<
  PostM360FeedbackMutationResponse,
  PostM360FeedbackMutationVariables
> = gql`
  mutation PostM360Feedback($message: String!, $pageUrl: String) {
    postM360Feedback(message: $message, pageUrl: $pageUrl) {
      success
      message
    }
  }
`;
